import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { Button } from "@/components";

const PhotoViewProvider = ({
  imageURL,
  label = "Document",
  labelClassName = "",
  spanClassName = "",
}) => {
  return (
    <PhotoProvider>
      <div className="w-full flex flex-col gap-1">
        {/* URL Link and View Button */}
        <div className="flex flex-row gap-2 items-center bg-secondary/10 p-1 rounded-2xl">
          {/* View Button */}
          <PhotoView src={imageURL} className="cursor-pointer">
            <div className="flex flex-row gap-2 items-center shrink-0 grow-0">
              <img
                src={
                  imageURL ||
                  "https://dummyimage.com/600x600/1e1f1e/b6bab6&text=No+Image"
                }
                alt={label}
                className="w-20 h-20 rounded-xl bg-secondary/70 text-background"
              />
            </div>
          </PhotoView>

          {/* URL Link */}
          <div className="flex flex-col gap-2">
            <p className="text-secondary/90 font-bold font-nunito text-caption md:text-body1 line-clamp-1 pl-0.5 pr-2">
              {label}
            </p>
            <a
              href={imageURL}
              target="_blank"
              rel="noopener noreferrer"
              download={label}
              className={`text-background/90 bg-secondary/95 w-fit p-3 leading-none  rounded-xl text-caption md:text-body2 font-nunito underline-none line-clamp-1 outline-none border-none grow-0 shrink-0 pb-2.5 hover:bg-secondary/85 transition-all ease-in-out duration-100 ${spanClassName}`}
            >
              Download
            </a>
          </div>
        </div>
      </div>
    </PhotoProvider>
  );
};

export default PhotoViewProvider;
